import * as React from 'react';
import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { patchApi } from 'views/services/api';
import { useParams } from 'react-router';

const ExtraChargeDialog = ({ open, handleClose, data }) => {
    const params = useParams();
    const reservationId = params.id;

    console.log(" reservationId : ",reservationId);
    console.log(" data : ",data._id);
    

  const formik = useFormik({
    initialValues: {
        reason: 'Extended stay beyond checkout',
        charges: ''
    },
    validationSchema: Yup.object({
      reason: Yup.string().required('Reason is required'),
      charges: Yup.number().required('Charges are required')
    }),

    onSubmit: async (values) => {
      console.log('Submitted values ===========>', values);
      try {
        console.log("url hit ==>", `api/reservation/addExtraStayCharges/${reservationId || data._id}`);
        let result = await patchApi(`api/reservation/addExtraStayCharges/${reservationId || data._id}`,values);
        console.log("result : ",result);
        
        if (result.status === 200) {
          toast.success("Charges Added Successfully !!");
          handleClose();
          formik.resetForm();
        } else {
          toast.error(result?.response?.data?.error);
          toast.error('Something went wrong');
        }
      } catch (error) {
        console.log(error);
      }
    }
  });

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="extra-charge-dialog">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Add Extra Charge</Typography>
        <ClearIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
      </DialogTitle>
      <DialogContent dividers>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="reason"
                name="reason"
                label="Reason"
                variant="outlined"
                size="small"
                value={formik.values.reason}
                onChange={formik.handleChange}
                error={formik.touched.reason && Boolean(formik.errors.reason)}
                helperText={formik.touched.reason && formik.errors.reason}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="charges"
                name="charges"
                label="Charges"
                variant="outlined"
                size="small"
                type="number"
                value={formik.values.charges}
                onChange={formik.handleChange}
                error={formik.touched.charges && Boolean(formik.errors.charges)}
                helperText={formik.touched.charges && formik.errors.charges}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="error">
          Cancel
        </Button>
        <Button onClick={formik.handleSubmit} variant="contained" color="primary">
          Add Charge
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtraChargeDialog;
